/**
 * @file Controlled drugs admin modal routing.
 */

import { openStandardForm } from '../../shared/forms/standardFormModal.js';
import { captureDrugRoleFormBaseline } from './drugAdminSubmit.js';
import {
    formModalElement,
} from '../../shared/forms/modalShell.js';
import {
    getDrugInventoryFormFields,
    getDrugRoleFormFields,
} from './drugAdminForms.js';
import {
    applyDrugControlSurface,
    bindDrugNativeFieldSurface,
    DRUG_CANCEL_BUTTON_CLASSES,
} from './drugControlStyles.js';
import {
    appData,
} from '../../app/state/state.js';

function applyDrugAdminModalActions(itemForm) {
    const cancelBtn = document.getElementById('cancel-form-btn');
    const submitBtn = itemForm?.querySelector('button[type="submit"]');
    if (!cancelBtn || !submitBtn) {return;}

    cancelBtn.className = DRUG_CANCEL_BUTTON_CLASSES;
    submitBtn.className = [
        "inline-flex h-9 items-center justify-center rounded-md border border-[var(--dfc-brand-primary)]",
        "bg-[var(--dfc-brand-primary)] px-4 text-sm font-semibold text-[var(--dfc-brand-primary-contrast)] transition-colors",
        "hover:bg-[var(--dfc-brand-primary-hover)] focus:outline-none focus-visible:bg-[var(--dfc-brand-primary-hover)]",
        "disabled:cursor-not-allowed disabled:opacity-50",
    ].join(" ");
}

/**
 * Opens the drug inventory admin modal.
 * @param {object | null} item Existing drug inventory item or defaults.
 * @returns {void}
 */
export function openDrugInventoryForm(item = null) {
    openStandardForm('drug_inventory', item, {
        getFieldsHtml: getDrugInventoryFormFields,
        afterRender: ({ formFields, itemForm }) => {
            applyDrugControlSurface(formModalElement, appData);
            applyDrugControlSurface(itemForm, appData);
            applyDrugControlSurface(formFields, appData);
            bindDrugNativeFieldSurface(itemForm);
            applyDrugAdminModalActions(itemForm);
        },
    });
}

/**
 * Opens the drug role admin modal.
 * @param {object | null} item Existing drug role item or defaults.
 * @returns {void}
 */
export function openDrugRoleForm(item = null) {
    openStandardForm('drug_role', item, {
        getFieldsHtml: getDrugRoleFormFields,
        afterRender: ({ formFields, itemForm }) => {
            captureDrugRoleFormBaseline(itemForm, item);
            applyDrugControlSurface(formModalElement, appData);
            applyDrugControlSurface(itemForm, appData);
            applyDrugControlSurface(formFields, appData);
            bindDrugNativeFieldSurface(itemForm);
            applyDrugAdminModalActions(itemForm);
        },
    });
}
